import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full font-medium tracking-[0.01em] whitespace-nowrap',
  {
    variants: {
      tone: {
        neutral: 'bg-paper-3 text-ink-2',
        success: 'bg-success-bg text-success',
        warn: 'bg-warn-bg text-warn',
        danger: 'bg-destructive-bg text-destructive',
        info: 'bg-info-bg text-info',
        outline: 'bg-transparent text-muted border border-line',
        medication: 'bg-medication-bg text-medication',
        consumable: 'bg-consumable-bg text-consumable',
        'medical-device': 'bg-medical-device-bg text-medical-device',
        reagent: 'bg-reagent-bg text-reagent',
        other: 'bg-other-bg text-other',
      },
      size: {
        sm: 'h-[18px] px-1.5 text-[10.5px]',
        md: 'h-[22px] px-2 text-[11.5px]',
        lg: 'h-[26px] px-2.5 text-xs',
      },
    },
    defaultVariants: { tone: 'neutral', size: 'md' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  dot?: boolean;
}

export function Badge({ className, tone, size, dot, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ tone, size }), className)} {...props}>
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />}
      {children}
    </span>
  );
}

export { badgeVariants };
